import { storyblokEditable } from '@storyblok/react/rsc'
import Typography from '@audioeye-marketing/ui/src/components/Typography'
import generateIdFromText from '@/lib/generate-id-from-text'

const Eyebrow = ({ blok }) => {
  return (
    <Typography level="eyebrow" id={generateIdFromText(blok?.eyebrow)} {...storyblokEditable(blok)}>
      {blok?.eyebrow}
    </Typography>
  )
}

export default Eyebrow
